import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Form } from 'reactstrap';
import { useFormik } from 'formik';
import { validationSchema } from './validation';
import Datagrid from '../../../UI/Datagrid';
import Moment from 'moment';
import TimeSelector from '../../../UI/TimeSelector';
import { Button, Dropdown } from '../../../UI/Common';
import ReactSelect from '../../../UI/ReactSelect';

const searchId = 'audit-search-bar';
function AuditReportsPage(props) {
  //prettier-ignore
  const { t, isFetching, departments, auditReports, datagridProps, initDeptId, initDeptName } = props;
  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      departmentId: initDeptId,
      fromDate: Moment().startOf('month').format('MM/DD/yyyy HH:mm:ss'),
      toDate: Moment().format('MM/DD/yyyy HH:mm:ss'),
      departmentIdText: initDeptName,
    },
    validationSchema,
    onSubmit: (values) => props.onFilter(values),
  });
  const extraExportOptions = [
    {
      name: 'Export to CSV',
      action: () => exportAudit('csv'),
    },
    {
      name: 'Export to PDF',
      action: () => exportAudit('pdf'),
    },
  ];
  function exportAudit(format) {
    props.onExportAudit(format, {
      Start: formik.values.fromDate,
      End: formik.values.toDate,
      DepartmentId: formik.values.departmentId,
    });
  }

  return (
    <Backend>
      <div className="content-inner">
        <Form>
          <ReactSelect
            required
            containerStyle={{ width: '30%' }}
            isClearable={false}
            label="Department"
            options={departments}
            value={formik.values.departmentId}
            onChange={({ value }) => {
              formik.setFieldValue('departmentId', value);
            }}
            valueKey="id"
            labelKey="name"
            invalid={formik.touched.departmentId}
            error={formik.errors.departmentId}
          />
          {/* <Dropdown
            type="dynamic"
            required
            includeZero
            label="Department"
            data={departments}
            value={formik.values.departmentId}
            onChange={({ value }) => {
              formik.setFieldTouched('departmentId', false);
              formik.setFieldValue('departmentId', value);
            }}
            valueKey="id"
            nameKey="name"
            invalid={formik.touched.departmentId}
            error={formik.errors.departmentId}
          /> */}
          <TimeSelector
            onChange={(fromDate, toDate) => {
              formik.setFieldValue('fromDate', fromDate);
              formik.setFieldValue('toDate', toDate);
            }}
          />
          <Button
            id="submit-filter-audit"
            loading={isFetching}
            onClick={formik.handleSubmit}
          >
            <i className="md-icon">filter_alt</i>
            {t('Run Report')}
          </Button>
        </Form>
        <div>
          <Datagrid
            remote
            onTableChange={props.onTableChange}
            datagridProps={{
              keyField: 'id',
              data: auditReports,
              loading: isFetching,
              ...datagridProps,
            }}
            searchProps={{
              remote: true,
              onSearch: props.onSearch,
              searchText: props.searchText,
              id: searchId,
            }}
            customPagination={{
              dataSize: props.totalRecords,
              page: props.page,
              sizePerPage: props.size,
            }}
            customExportProps={extraExportOptions}
          />
        </div>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(AuditReportsPage);
